import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import richTextFragmentCut from '@components/renderers/rich-text.fragment-cut'
import CustomPage from './custom-page'

const CUSTOM_PAGE_QUERY = gql`
query getCustomPageHero($where: CustomPageFilter!, $preview: Boolean)  {
  customPageCollection(limit: 1, preview: $preview, where: $where)  {
    items {
      includeSubNav
      pageTitle
      pageDescription
      slug
      route
      metaImage {
        url
      }
      heroHeadline
      heroEyebrow
      heroSummary {
        ${richTextFragmentCut}
      }
      heroBackground {
        url
        title
        width
        height
        description
        contentType
      }
      showHeroBackgroundOverlay
      primaryCtaText
      primaryCtaUrl
      secondaryCtaText
      secondaryCtaUrl
      quickLinks {
        heading
        summary {
          ${richTextFragmentCut}
        }
        linksCollection {
          items {
            ctaText
            ctaUrl
            ctaIcon {
              url
            }
          }
        }
      }
    }
  }
}
`

export { CUSTOM_PAGE_QUERY }

export default function CustomPageWithData(props) {
  const { query, route, ssrData } = props

  // If SSR data is provided, render directly
  if (ssrData !== undefined) {
    return ssrData ? (
      <CustomPage {...ssrData} {...props} />
    ) : (
      <Error statusCode={404} />
    )
  }

  const where = query.slug
    ? { route, slug: query.slug }
    : { route, slug_exists: false }

  // Fallback to client-side fetching
  return (
    <Query
      query={CUSTOM_PAGE_QUERY}
      variables={{ where, preview: query.preview }}
    >
      {({ loading, error, data }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />

        const response = data.customPageCollection && data.customPageCollection.items[0]

        return response ? (
          <CustomPage {...response} {...props} />
        ) : (
          <Error statusCode={404} />
        )
      }}
    </Query>
  )
}

CustomPageWithData.propTypes = {
  query: PropTypes.object,
  route: PropTypes.string,
  ssrData: PropTypes.object,
}
